import React, { useContext, useState, useEffect } from 'react';
import { Radio, RadioGroup } from 'rsuite';
import { ReactComponent as EditIcon } from '../../../assets/svg/edit.svg';
import { ReportsService } from '../../../services';
import './custom-metric.scss';
import { UserContext } from '../../../context';
import { Dropdown } from '../../atoms';
import { default as t } from '../../../utils/i18n';

const CustomMetric = ({ handleOpenSliderModal, performanceMetrics, stepperData, edirMetrics,draftReportId, existResponse }) => {
  const [cutomMetricDetails, setCustomMetricDetails] = useState({});
  const [formulaDetails, setFormulaDetails] = useState([]);
  const [allReports, setAllReports] = useState(false);
  const [allReportsVal, setAllReportsval] = useState('2');
  const { user } = useContext(UserContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const [searchKeyword, setSearchKeyword] = useState('');
  const [originalList, setOriginalList] = useState([]);
  const [performanceMetric, setPerformanceMetrics] = useState([...performanceMetrics]);
  const [dataTypeOptions, SetDataTypeOptions] = useState([]);
  const [selectedDataType, setSelectedDataType]=useState({});
  const [errorMessage, setErrorMessage] = useState('')
  const reportId = draftReportId ? draftReportId : stepperData?.data?.data?.reportId;

  const operators = [
    {
      id: 1,
      value: '/',
      type: 'operator',
    },
    {
      id: 2,
      value: 'X',
      type: 'operator',
    },
    {
      id: 3,
      value: ')',
      type: 'operator',
    },
    {
      id: 4,
      value: '+',
      type: 'operator',
    },
    {
      id: 5,
      value: '(',
      type: 'operator',
    },
    {
      id: 6,
      value: '-',
      type: 'operator',
    },
  ];

  const OPTIONS = [
    {
      label: t('custom.metric.number.opt'),
      value: 'Number'
    },
    {
      label: t('custom.metric.currency.opt'),
      value: 'Currency'
    },
    {
      label: t('custom.metric.percent.opt'),
      value: 'Percentage'
    },
]

  useEffect(() => {
    setOriginalList([...performanceMetrics]);
    SetDataTypeOptions([...OPTIONS])
    if(!edirMetrics?.sys_id) {
      setCustomMetricDetails({});
    } else {
      setExistingEditDetails();
    }
  }, []);

  const setExistingEditDetails = () => {
    setCustomMetricDetails({
      customMetricName: edirMetrics?.KPI_Metric,
      customMetricDesc: edirMetrics?.description,
      visiblityScope: edirMetrics?.visiblityScope?.advertiser ? '1': '2'
    });
    setAllReports(edirMetrics?.visiblityScope?.advertiser ? true: false);
    setAllReportsval(edirMetrics?.visiblityScope?.advertiser ? '1': '2');
    if(performanceMetrics?.length > 0) {
      edirMetrics?.formula?.forEach(li => {
        if(li.type === 'metric') {
          li.value = performanceMetrics.find(metric => (metric?.value === li.value || metric?.sys_id === li.value))?.KPI_Metric;
        }
      })
    }
    setFormulaDetails([...edirMetrics?.formula]);
    const selectedVal = OPTIONS.find(opt => opt?.value?.toUpperCase() === edirMetrics?.data_type?.toUpperCase());
    setSelectedDataType(selectedVal);
  }

  const getMetricName = value => {
    if(edirMetrics?.sys_id) {
      edirMetrics.KPI_Metric = value;
    }
    setCustomMetricDetails({ customMetricName: value });
  };

  const getMetricDesc = value => {
    if(edirMetrics?.sys_id) {
      edirMetrics.description = value;
    }
    setCustomMetricDetails({
      ...cutomMetricDetails,
      customMetricDesc: value,
    });
  };

  const getTheFormula = value => {
    if (
      (!formulaDetails?.length && value?.type === 'operator' && (value?.value !== '(' && value?.value !== ')')) ||
      (formulaDetails?.length && formulaDetails[formulaDetails.length - 1]?.type === value?.type && (value?.value !== '(' && value?.value !== ')') &&       
      (formulaDetails[formulaDetails.length - 1]?.value !== '(') &&
      (formulaDetails[formulaDetails.length - 1]?.value !== ')'))
    ) {
      return;
    } else {
      setFormulaDetails([...formulaDetails, value]);
    }
  };

  const handleOperator = op => {
    const val = {
      type: op?.type,
      value: op?.value === 'X' ? '*' : op?.value,
    };
    getTheFormula(val);
  };

  const handleAvailableMetrics = avMetric => {
    const addedAv = {
      type: 'metric',
      value: avMetric?.KPI_Metric,
    };
    getTheFormula(addedAv);
  };

  const onDelete = addedMetric => {
    const pos = formulaDetails.findIndex(detail => detail?.value === addedMetric?.value);
    if (pos >= 0) {
      formulaDetails.splice(pos, 1);
    }
    setFormulaDetails([...formulaDetails]);
  };

  const onTextAdd = () => {
    const newAdd = {
      type: 'text',
      value: '',
    };
    getTheFormula(newAdd);
  };

  const getNumber = (value, detail, index) => {
    detail.value = value;
    formulaDetails[index].value = value;
    setFormulaDetails([...formulaDetails]);
  };

  const onChange = (value) => {
    const radioVal = value === '1' ? true : false;
    setAllReports(radioVal);
    setAllReportsval(value);
      setCustomMetricDetails({
        ...cutomMetricDetails,
        visiblityScope: radioVal,
      });
  };

  const onCreate = async () => {
    const adv = stepperData?.config?.data ? JSON?.parse(stepperData?.config?.data) : existResponse;
    const reportIdUpdated = stepperData?.data?.data?.reportId ? stepperData?.data?.data?.reportId : existResponse?.reportId;
    formulaDetails.forEach(li => {
      if(li.type === 'metric') {
        li.value = performanceMetrics.find(metric => metric?.KPI_Metric === li.value)?.sys_id;
      }
    })
    if(edirMetrics?.sys_id) {
      updateMetrics(adv, reportIdUpdated)
    } else {
      addMetrics(adv, reportIdUpdated);
    }
  };

  const addMetrics = async(adv, reportIdUpdated) => {
    try {
      const payload = {
        KPI_Metric: cutomMetricDetails?.customMetricName,
        description: cutomMetricDetails?.customMetricDesc,
        formula: formulaDetails,
        advertiser: adv?.advertiser,
        reportId: reportIdUpdated,
        data_type: selectedDataType?.value?.toUpperCase(),
        visiblityScope:
          allReportsVal === '1'
            ? { advertiser: adv?.advertiser }
            : { reportId: reportIdUpdated },
      };
      const customResponse = await ReportsService.createCustomMetric(
        userAccessToken,
        username,
        payload
      );
      let resultedCustomResponse = customResponse?.data?.data;
      if(resultedCustomResponse) {
        setErrorMessage('');
        handleOpenSliderModal(false, true);
      }
    } catch(error) {
      catchingError(error);
    }
  }

  const catchingError = (error) => {
    formulaDetails?.forEach(li => {
      if(li.type === 'metric') {
        li.value = performanceMetrics.find(metric => metric?.sys_id === li.value)?.KPI_Metric;
      }
    })
    setFormulaDetails([...formulaDetails]);
    let errorMsg = Array.isArray(error?.data?.data?.message) && error?.data?.data?.message?.length > 0 ? error?.data?.data?.message?.join(', ') : error?.data?.data?.message;
    setErrorMessage(errorMsg);
  }

  const updateMetrics = async(adv, reportIdUpdated) => {
    try {
      const payload = {
        KPI_Metric: edirMetrics?.KPI_Metric,
        description: edirMetrics?.description,
        formula: formulaDetails,
        advertiser: adv?.advertiser,
        reportId: reportIdUpdated,
        data_type: selectedDataType?.value?.toUpperCase(),
        visiblityScope:
        allReportsVal === '1'
            ? { advertiser: adv?.advertiser }
            : { reportId: reportIdUpdated },
      }
      const updateRes = await ReportsService.updateCustomMetrics( userAccessToken, username, payload, edirMetrics?.sys_id);
      let resultedRes = updateRes?.data?.data;
      if(resultedRes) {
        setErrorMessage('');
        handleOpenSliderModal(false, true);
      }
    } catch(error) {
      catchingError(error);
    }
  }

  const handleOnSelectDataType = (val) => {
    setSelectedDataType(val)
  }

  const closePopup = () => {
    formulaDetails?.forEach(li => {
      if(li.type === 'metric') {
        li.value = performanceMetrics.find(metric => metric?.sys_id === li.value)?.KPI_Metric;
      }
    })
    setFormulaDetails([...formulaDetails])
    handleOpenSliderModal(true)
  }

  const handleSearchOnChange = searchText => {
    const textedVal = searchText?.target?.value?.trim();
    setSearchKeyword(textedVal);
    let resulted = originalList.filter(item => {
      return (
        item?.KPI_Metric?.toLowerCase()?.includes(textedVal?.toLowerCase()) ||
        item?.name?.toLowerCase()?.includes(textedVal?.toLowerCase())
      );
    });
    setPerformanceMetrics([...resulted]);
  };

  const removeSearchedKey = () => {
    setSearchKeyword('');
    setPerformanceMetrics([...originalList]);
  };

  return (
    <>
      <div className="heading-container-modal edit-label">
        <div className="flexbox">
          <EditIcon />
          <p>{t('custom.metric.header')}</p>
        </div>
        <div onClick={closePopup}>
          <i
            data-tip="Edit nickname"
            data-for="tool-tip"
            className="eva eva-close-outline clear-icon close-btn"
            currentitem="false"
          ></i>
        </div>
      </div>
      <div>{ errorMessage?.length > 0 ? <p className='error'>{errorMessage}</p> :''}</div>
      <div>
        <p>{t('custom.metric.name')} <span className='imp-icon'>*</span></p>
        <input
          value ={cutomMetricDetails?.customMetricName}
          type="text"
          placeholder={t('custom.metric.enter.name')}
          maxLength={50}
          onChange={e => getMetricName(e.target.value)}
        />
      </div>
      <div>
        <p>{t('custom.metric.description')}</p>
        <input
          value ={cutomMetricDetails?.customMetricDesc}
          type="text"
          placeholder={t('custom.metric.add.description')}
          maxLength={50}
          onChange={e => getMetricDesc(e.target.value)}
        />
      </div>
      <div>
        <p>{t('curom.metric.formula')} <span className='imp-icon'>*</span></p>
        <div className="formula-container">
          {formulaDetails?.map((detail, index) => {
            if (detail?.type === 'text') {
              return (
                <div>
                  <input
                  value={detail?.value}
                    type="number"
                    className="input-num"
                    placeholder={t('custom.metric.number')}
                    maxLength={50}
                    onChange={e => getNumber(e.target.value, detail, index)}
                  />
                  <span className='icon-container'>
                  <i
                    data-tip="Edit nickname"
                    data-for="tool-tip"
                    className="eva eva-close-outline clear-icon close-btn formula-close"
                    currentitem="false"
                    onClick={() => onDelete(detail)}
                  ></i>
                  </span>
                </div>
              );
            } else {
              return (
                <div>
                  <span>{detail?.value}</span>
                  <span className='icon-container'>   
                  <i
                    data-tip="Edit nickname"
                    data-for="tool-tip"
                    className="eva eva-close-outline clear-icon close-btn formula-close"
                    currentitem="false"
                    onClick={() => onDelete(detail)}
                  ></i></span>
                </div>
              );
            }
          })}
        </div>
      </div>
      <p className='note-text'>{t('custom.metric.op.header')}</p>
      <div className="operator-container">
        <p>{t('custom.metric.operators')}</p>
        <div>
          {operators.map(op => {
            return <span onClick={() => handleOperator(op)}>{op?.value}</span>;
          })}
        </div>
      </div>
      <div className="text-box-container">
        <p>{t('custom.metric.textbox')}</p>
        <button onClick={() => onTextAdd()}>{t('custom.metrics.text')}</button>
      </div>
      <div className="available-metrics-container-cus">
        <p>{t('custom.metrics.available.metrics')}</p>
        <div className="search-bar">
          <div className="c-search-bar c-search-bar--input">
            <i className="eva eva-search-outline search-icon"></i>
            <input
              className="c-search-input"
              type="text"
              placeholder={t('custom.metric.search')}
              value={searchKeyword}
              name="search"
              autoComplete="off"
              onChange={handleSearchOnChange}
            />
            <i
              className="eva eva-close-outline clear-icon search-icon"
              onClick={() => removeSearchedKey()}
            ></i>
          </div>
        </div>
        <div className="metric-values">
          {performanceMetric?.map(perfMetric => {
            if (perfMetric?.KPI_Metric) {
              return (
                <div className="metric-data">
                  <p
                    title="perfMetric?.KPI_Metric"
                    onClick={() => handleAvailableMetrics(perfMetric)}
                  >
                    {perfMetric?.KPI_Metric}
                  </p>
                </div>
              );
            }
          })}
        </div>
      </div>
      <div>
              <div className='data-type-align'>
                <Dropdown
                  className="user-select"
                  heading={t('custom.metric.datatype')}
                  value={selectedDataType}
                  options={dataTypeOptions}
                  onSelect={handleOnSelectDataType}
                  placeholder={t('custom.metric.select')}
                  isImportant={true}
                />
    </div>
      </div>

      <div className="metric-visibility">
        <p>{t('custom.metric.metric.visibility')}</p>
        <span>
          <RadioGroup name="visibility_scope"
           value={allReportsVal}
           onChange={value => {
             onChange(value);
           }}>
            <Radio value='1'>{t('custom.metric.allreports')}</Radio>
            <Radio value='2'>{t('custom.metric.thisreport')}</Radio>
          </RadioGroup>
        </span>
      </div>
      <div className="button-container">
        <button className="cancel-btn" onClick={closePopup}>
          {t('custom.metric.cancel')}
        </button>
        <button 
        className={ (cutomMetricDetails?.customMetricName && formulaDetails?.length > 0 && selectedDataType?.value !== '') ? "step-next" : "step-next disabled"} 
        disabled = {!cutomMetricDetails?.customMetricName|| !formulaDetails?.length || !selectedDataType?.value}
        onClick={() => onCreate()}>
          {edirMetrics?.sys_id ? t('Save'): t('Create')}
        </button>
      </div>
      <div>
        <button className={['btn', 'close_btn'].join(' ')} type="button">
          <span className="icon-ico-close"></span>
        </button>
      </div>
    </>
  );
};

export default CustomMetric;
